<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<h1 class="Poem-title" id="_idParaDest-5" lang="en-GB"><a id="_idTextAnchor006"></a>Ghetto a place</h1>
<p class="Verse-first" lang="en-GB">From the city centre take your left </p>
<p class="Verse-main" lang="en-GB">Then take your left again keep going</p>
<p class="Verse-main" lang="en-GB">Take your right then you will see the place</p>
<p class="Verse-main" lang="en-GB">It is called a depraved area</p>
<p class="Verse-main" lang="en-GB">A place where people are forgotten</p>
<p class="Verse-main" lang="en-GB">When remembered only for wrong deeds</p>
<p class="Verse-main" lang="en-GB">Remembered they are for their inabilities </p>
<p class="Verse-main" lang="en-GB">The inhabitants of this place are seen as:</p>
<p class="Verse-main" lang="en-GB">The ones wearing dark coats</p>
<p class="Verse-main" lang="en-GB">The ones whose darkness the face shows </p>
<p class="Verse-main" lang="en-GB">The under-classified ones</p>
<p class="Verse-main" lang="en-GB">Have no beauty how can they ever?</p>
<p class="Verse-main" lang="en-GB">Ghetto where is your sympathy?</p>
<p class="Verse-main" lang="en-GB">Where is your home?</p>
<p class="Verse-main" lang="en-GB">You are just a place</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781398406179_EPUB7.vue?6842382c